import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { Form, Button } from 'react-bootstrap';
import { useSearchParams, useLocation } from "react-router-dom";

/* import component from components folder */
import Select from '../components/select';

const Search = ({ resource, controlDefault = {}, options, parameter, onSubmit }) => {    
    const { RangePicker } = DatePicker;
    const { search } = useLocation();
    const [ searchParams ] = useSearchParams();
    const { control, select, datetimer } = resource || {};
    const [status, setStatus] = useState({});
    const [requires, setRequires] = useState([]);

    const intervalPickerHandler = dates => {
        let _source = Object.assign({}, status);
        
        if (!dates) {
            delete _source.startDate;
            delete _source.endDate;
        }
        else {
            const startDate = `${dates[0].$y}-${dates[0].$M + 1}-${dates[0].$D}`;
            const endDate = `${dates[1].$y}-${dates[1].$M + 1}-${dates[1].$D}`;

            _source.startDate = new Date(startDate).getTime();
            _source.endDate = new Date(endDate).getTime();
        }
        
        setStatus(_source);
    };

    const pickerHandler = dates => {
        let _source = Object.assign({}, status);

        if (!dates)
            delete _source.searchDate;
        else {
            const searchDate = `${dates.$y}-${dates.$M + 1}-${dates.$D}`;

            _source.searchDate = new Date(searchDate).getTime();
        }

        setStatus(_source);
    };

    const changHandler = ({target, target: { name, value }}) => {
        let _source = Object.assign({}, status);
        
        if (value === '')
            delete _source[name];
        else
            _source[name] = value;

        setStatus(_source);
    };

    const verifyRequest = () => {
        const targets = Object.keys(resource);
        let _requires = [];

        targets.map( target => {
            const verifier = resource[target].filter(({ require }) => require === true);

            if (verifier.length) {
                const verified = verifier.filter(({ key }) => !status[key]);
                const errors = requireHandler(verified);

                _requires = [..._requires, ...errors];

                setRequires(_requires);
            }
        });
        
        return !_requires.length;
    };

    const requireHandler = verified => {
        const _requires = [];
        
        verified.map(({ key }) => {    
            if (key === 'intervalTimer') {
                if (!status.startDate || !status.endDate)
                    _requires.push(key);
            }
            else if (!status[key]) {
                _requires.push(key);
            }            
        });
        
        return _requires
    }

    const submitHandler = event => {
        event.preventDefault();
        const isVerify = verifyRequest();
        
        if (isVerify)
            onSubmit(status);
    };

    useEffect(() => {
        const _source = Object.assign({}, status);

        for (const entry of searchParams.entries()) {
            const key = entry[0];
            const value = entry[1];

            _source[key] = value;
        }
        
        if (Object.keys(_source).length)
            setTimeout(() => { onSubmit(_source); }, 500);
    }, []);

    return (
        <Form className="search-container" onSubmit={ submitHandler }>
            {
                control?.map(({ type, key, placeholder }) => {
                    const _defaultValue = new URLSearchParams(search).get(key) || controlDefault[key];

                    return (
                        <div key={ key } className="search-item">
                            <Form.Control type={ type } name={ key } placeholder={ placeholder } defaultValue={ _defaultValue } is-required={ `${requires.includes(key)}` } data-shadow onChange={ changHandler } />
                        </div>
                    )
                })
            }
            {
                select?.map(({ key, label, all_option, _default }) => {
                    const _defaultValue = new URLSearchParams(search).get(key) || _default;
                    const option = options ? options[key] : [];

                    return (
                        <div key={ key } className="search-item">
                            <Select label={ label } name={ key } options={ option } _default={ _defaultValue } required={ requires.includes(key) } changHandle={ changHandler } />
                        </div>
                    )
                })
            }
            {
                datetimer?.map(({ key, placeholder, require }) => (
                    <div key={ key } className="search-item">
                        { key === 'intervalTimer' && <RangePicker className='form-picker' status={ requires.includes(key) && 'error' } onChange={ intervalPickerHandler } /> }
                        { key === 'datetimer' && <DatePicker className='form-picker' onChange={ pickerHandler } /> }
                    </div>
                ))
            }
            <div type="button" className="search-item">
                <Button type="submit" data-shadow>Search</Button>
            </div>
        </Form>
    );
};

export default React.memo(Search);